import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import styles from "./index.module.css";

import { ReactComponent as Left } from "../../../../assets/icons/left-arrow.svg";
import { ReactComponent as Right } from "../../../../assets/icons/right-arrow.svg";

// only for Work page
const Navigation = ({ data }) => {
  const links = data.map(v => decodeURI(v.link));
  const current = decodeURI(window.location.pathname);

  const fullpath = links.filter(v => v.includes(current))[0];
  const currentIndex = fullpath && links.indexOf(fullpath);

  const prev =
    links[currentIndex - 1] &&
    "/works" + links[currentIndex - 1].split("/works").slice(-1)[0];

  const next =
    links[currentIndex + 1] &&
    "/works" + links[currentIndex + 1].split("/works").slice(-1)[0];

  const Prev = () => {
    if (currentIndex <= 0) {
      return (
        <div className={`${styles.disabled} ${styles.arrowContainer}`} disabled>
          {/* <Left className={styles.arrow} /> */}
          {"<"}
        </div>
      );
    } else {
      return (
        <Link to={prev || "/"} className={styles.arrowContainer}>
          {/* <Left className={styles.arrow} /> */}
          {"<"}
        </Link>
      );
    }
  };

  const Next = () => {
    if (currentIndex >= links.length - 1) {
      return (
        <div className={`${styles.disabled} ${styles.arrowContainer}`} disabled>
          {/* <Right className={styles.arrow} /> */}
          {">"}
        </div>
      );
    } else {
      return (
        <Link to={next || "/"} className={styles.arrowContainer}>
          {/* <Right className={styles.arrow} /> */}
          {">"}
        </Link>
      );
    }
  };

  return (
    <motion.div
      className={styles.navigationContainer}
      initial={{ opacity: 0 }}
      animate={"active"}
      variants={{
        active: { opacity: 1, transition: { delay: 1 } },
        inactive: { opacity: 0, transition: { delay: 0 } }
      }}
    >
      <div className={styles.navigation}>
        <Prev />
        <span className={styles.navText}>{`${currentIndex + 1} /${
          links.length
        }`}</span>
        <Next />
      </div>
    </motion.div>
  );
};

export default Navigation;
